// extracted by mini-css-extract-plugin
export default {"root":"EmptyContainer_root__Tarw3"};